import { companiesApi } from '../../../services/api/companiesApi'
import moment from 'moment'

export const transformCompaniesResponse = async (pagination) => {
  const res = await companiesApi.unread(pagination)

  if (!res.data.success) {
    return []
  }

  const { companies, documents } = res.data

  const result = {}

  for (let i = 0; i < companies.length; i++) {
    let company = companies[i]

    company.unread = 0
    company.updatedAt = moment(company.updatedAt).format('YYYY-MM-DD')
    result[company.id] = company
  }

  for (let i = 0; i < documents.length; i++) {
    let document = documents[i]

    result[document.parent].unread++
  }

  return flatten(result)
}

function flatten (object) {
  const res = []

  for (let key in object) {
    if (!object.hasOwnProperty(key)) continue

    res.push(object[key])
  }

  return res
}
